/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-location': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#6ca2ca"><path pid="0" d="M15.354 4.646a7.571 7.571 0 0 1 0 10.708l-5 5a.5.5 0 0 1-.708 0l-5-5A7.571 7.571 0 1 1 15.354 4.646zM10 19.293l4.646-4.647a6.571 6.571 0 1 0-9.292 0z"/><path pid="1" d="M10 11.63a2.284 2.284 0 1 0 0-4.57 2.284 2.284 0 0 0 0 4.57zm0-1a1.284 1.284 0 1 1 0-2.57 1.284 1.284 0 0 1 0 2.57z"/></g>'
  }
})
